import React, { FC } from 'react'
import { Table, TableBody } from 'transfix-ui/components/Table'
import { makeStyles } from 'transfix-ui/core/styles'
import { Maybe } from 'types/graphqlTypes'
import { LaneAlert } from 'apps/marketplace/apiTypes/carrierLaneAlerts'
import { SavedLanesTableEmpty } from './SavedLanesTableEmpty/SavedLanesTableEmpty'
import { SavedLanesTableHeader } from './SavedLanesTableHeader/SavedLanesTableHeader'
import { SavedLanesTableRow } from './SavedLanesTableRow/SavedLanesTableRow'

export interface ISavedLanesTableProps {
  savedLanes: Maybe<LaneAlert[]>
  onDelete: (savedLane: LaneAlert) => void
  onEdit: (savedLane: LaneAlert) => void
}
const useSavedLanesTableStyles = makeStyles({ root: { width: '100%' } })

export const SavedLanesTable: FC<ISavedLanesTableProps> = ({ onDelete, onEdit, savedLanes }) => {
  const classes = useSavedLanesTableStyles()

  return (
    <Table className={classes.root} dataTest='saved-lanes-table'>
      <SavedLanesTableHeader />
      <TableBody>
        {savedLanes && savedLanes.length > 0 ? (
          <>
            {savedLanes.map(savedLane => (
              <SavedLanesTableRow
                key={savedLane.id}
                savedLane={savedLane}
                onDelete={onDelete}
                onEdit={onEdit}
              />
            ))}
          </>
        ) : (
          <SavedLanesTableEmpty />
        )}
      </TableBody>
    </Table>
  )
}
